import {
  SET_TRATAMIENTO,
  SET_NOMBRE_VTP_USADOS,
  SET_APELLIDO_MATERNO_VTP_USADOS,
  SET_APELIIDO_PATERNO_VTP_USADOS,
  SET_ESTADO_VTP_USADOS,
  SET_CIUDAD_VTP_USADOS,
  SET_ID_CONCESIONARIO_VTP_USADOS,
  SET_CONCESIONARIO_VTP_USADOS,
  SET_TELEFONO_VTP_USADOS,
  SET_MOVIL_VTP_USADOS,
  SET_CORREO_VTP_USADOS,
  SET_COMENTARIOS_VTP_USADOS,
  SET_SEXO,
  SET_AVISO_PRIVACIDAD_VTP_USADOS,
  SET_TERMINOS_Y_CONDICIONES_VTP_USADOS,
  SET_TRANSFERENCIA_DE_DATOS_VTP_USADOS,
  SET_CONTACO_MARKETING_VTP_USADOS,
  SET_VEIHICULO_VTP_USADOS,
  SET_TIPO_CITA_VTP_USADOS,
  RESET_STATE_VTP_USADOS,
} from "../types";

const initialState = {
  fuenteSitioWeb: "Sitio Web Audi - VTP",
  marca: "Audi",
  tipoRegistro: "Importador",
  fuenteSecundaria: "Medios Digitales Importador",
  tercerNivel: "Sitio Web Audi - VTP usados",
  llaveOrigen: "AUSW",
  tratamiento: "Sr",
  nombre: "",
  apellidoMaterno: "",
  apellidoPaterno: "",
  telefono: "",
  celular: "",
  email: "",
  ciudad: "",
  provincia: "",
  concesionariaPreferida: "",
  vehiculoActual: "",
  descripcion: "",
  permisoTransferenciaDatos: false,
  permisoContactoMarketing: false,
  urlWeb: "http://www.audi.com.mx/",
  tipoCita: "",
  fechaNacimiento: "",
  numeroConcesionaria: "",
  horarioPreferente: "",
  fechaPreferente: "",
  vehiculoInteres: "",
  urlPrivacidad: "http://www.audi.com.mx/mx/web/es.html",
  sexo: "Masculino",
  status: "Nuevo",
  fbCampaignID: "",
  //datos extra para el formulario
  avisoPrivacidad: false,
  terminosCondiciones: false,
  nombreDelVehiculo: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TRATAMIENTO:
      return {
        ...state,
        tratamiento: action.payload,
      };
    case SET_NOMBRE_VTP_USADOS:
      return {
        ...state,
        nombre: action.payload,
      };
    case SET_APELLIDO_MATERNO_VTP_USADOS:
      return {
        ...state,
        apellidoMaterno: action.payload,
      };
    case SET_APELIIDO_PATERNO_VTP_USADOS:
      return {
        ...state,
        apellidoPaterno: action.payload,
      };
    case SET_ESTADO_VTP_USADOS:
      return {
        ...state,
        provincia: action.payload,
      };
    case SET_CIUDAD_VTP_USADOS:
      return {
        ...state,
        ciudad: action.payload,
      };
    case SET_ID_CONCESIONARIO_VTP_USADOS:
      return {
        ...state,
        numeroConcesionaria: action.payload,
      };
    case SET_CONCESIONARIO_VTP_USADOS:
      return {
        ...state,
        concesionariaPreferida: action.payload,
      };
    case SET_TELEFONO_VTP_USADOS:
      return {
        ...state,
        telefono: action.payload,
      };
    case SET_MOVIL_VTP_USADOS:
      return {
        ...state,
        celular: action.payload,
      };
    case SET_CORREO_VTP_USADOS:
      return {
        ...state,
        email: action.payload,
      };
    case SET_COMENTARIOS_VTP_USADOS:
      return {
        ...state,
        descripcion: action.payload,
      };
    case SET_SEXO:
      return {
        ...state,
        sexo: action.payload,
      };
    case SET_AVISO_PRIVACIDAD_VTP_USADOS:
      return {
        ...state,
        avisoPrivacidad: action.payload,
      };
    case SET_TERMINOS_Y_CONDICIONES_VTP_USADOS:
      return {
        ...state,
        terminosCondiciones: action.payload,
      };
    case SET_TRANSFERENCIA_DE_DATOS_VTP_USADOS:
      return {
        ...state,
        permisoTransferenciaDatos: action.payload,
      };
    case SET_CONTACO_MARKETING_VTP_USADOS:
      return {
        ...state,
        permisoContactoMarketing: action.payload,
      };
    case SET_VEIHICULO_VTP_USADOS:
      return {
        ...state,
        vehiculoInteres: action.payload,
      };
    case SET_TIPO_CITA_VTP_USADOS:
      return {
        ...state,
        tipoCita: action.payload,
      };
    case RESET_STATE_VTP_USADOS:
      return initialState;
    default:
      return state;
  }
}
